import { motion } from "framer-motion";

const EASE = [0.215, 0.61, 0.355, 1];

export const Reveal = ({ children, delay = 0, y = 26, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.75, delay, ease: EASE }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const RevealLine = ({ children, delay = 0, className = "" }) => (
  <motion.span
    className={`block overflow-hidden ${className}`}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-40px" }}
  >
    <motion.span
      className="block"
      variants={{
        hidden: { y: "112%" },
        show: { y: "0%", transition: { duration: 0.9, delay, ease: EASE } },
      }}
    >
      {children}
    </motion.span>
  </motion.span>
);
